import { GeneratePushID } from './GeneratePushID.js';

// This will not work in a functions context and will need to be reworked.
window.repeatHandlers = window.repeatHandlers || {};
export function Repeat(key, callback, updateDuration, options) {
  key ??= GeneratePushID();
  options = options || {};
  options.rate = options.rate || 20; // Default to 50 fps.
  if (callback) {
    if (!window.repeatHandlers[key]) window.repeatHandlers[key] = {};
    // Time that this update request will end.
    let endTime = new Date().getTime() + updateDuration;
    // If there is a timeout handler and it will finish before this new update request would like update to run, overwrite it.
    if (!window.repeatHandlers[key].endTime || endTime > window.repeatHandlers[key].endTime) {
      // Clear timeout to make way for the new one.
      if (window.repeatHandlers[key].timeout) window.clearTimeout(window.repeatHandlers[key].timeout);
      // Run when update stops.
      window.repeatHandlers[key].timeout = window.setTimeout(() => {
        if (window.repeatHandlers[key].interval) window.clearInterval(window.repeatHandlers[key].interval);
        window.repeatHandlers[key].interval = window.repeatHandlers[key].timeout = window.repeatHandlers[key].endTime = null;
      }, updateDuration);
      // Save new end time.
      window.repeatHandlers[key].endTime = endTime;
    }
    // If there is no update interval, start one. Runs every options.rate milliseconds.
    if (!window.repeatHandlers[key].interval) window.repeatHandlers[key].interval = window.setInterval(callback, options.rate);
  } else console.warn('callback is undefined');
  return key;
}
